
export const paginationParams = (linkHeader = '', totalHeader = 0) => {
  const links = linkHeader.split(',')
  const total = totalHeader
  const next = links.find(item => item.indexOf('rel="next"') > 0)
  const last = links.find(item => item.indexOf('rel="last"') > 0)
  const prev = links.find(item => item.indexOf('rel="prev"') > 0)

  let page = 1
  let pages = 1

  if (last) {
    pages = parseInt(last.match(/page=(\d+).*$/)[1], 10) || 0
    page = parseInt(next.match(/page=(\d+).*$/)[1], 10) - 1 || 0
  } else if (prev) {
    pages = parseInt(prev.match(/page=(\d+).*$/)[1], 10) + 1 || 0
    page = pages
  }
  return {
    total,
    page,
    pages
  }
}
